import { tr } from "date-fns/locale";
import {
  CREATE_SCOPED_ANOMALY_RULE_SUCCESS,
  CREATE_SCOPED_ANOMALY_RULE_FAILURE,
  FETCH_SCOPED_ANOMALY_RULE_FAILURE,
  FETCH_SCOPED_ANOMALY_RULE_SUCCESS,
  DELETE_SCOPED_ANOMALY_RULE_SUCCESS,
  DELETE_SCOPED_ANOMALY_RULE_FAILURE,
  UPDATE_SCOPED_ANOMALY_RULE_FAILURE,
  UPDATE_SCOPED_ANOMALY_RULE_SUCCESS,
  CLEAR_SCOPED_ANOMALY_STATE,
  FETCH_ANOMALY_HMI_SUCCESS,
  FETCH_ANOMALY_HMI_FAILURE,
  FETCH_ANOMALY_NODE_SUCCESS,
  FETCH_ANOMALY_NODE_FAILURE,
  FETCH_ANOMALY_FUNCTION_SUCCESS,
  FETCH_ANOMALY_FUNCTION_FAILURE,
  HMI_REQUEST,
  NODE_REQUEST,
  FUNCTION_REQUEST,
  CLEAR_TYPE_HMI,
  CLEAR_TYPE_NODE,
  CLEAR_TYPE_FUNCTION
} from "../_constants";

const initialState = {
  loading: false,
  error: "",
  createError: "",
  scopedAnomalyCreated: false,
  updatedScopedAnomalySuccess: false,
  updatedScopedAnomalyFailure: false,
  scopedAnomalyRule: "",
  deleteSuccess: false,
  hmi: [],
  node: [],
  function: [],
  hmiLoading:false,
  nodeLoading:false,
  functionLoading:false,
};

export const scopedAnomalyRuleReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SCOPED_ANOMALY_RULE_SUCCESS:
      return {
        ...state,
        scopedAnomalyCreated: true,
        createError: "",
      };
    case CREATE_SCOPED_ANOMALY_RULE_FAILURE:
      return {
        ...state,
        createError: action.payload,
      };

    case FETCH_SCOPED_ANOMALY_RULE_SUCCESS:
      return {
        ...state,
        scopedAnomalyRule: action.payload,
        error: "",
      };

    case FETCH_SCOPED_ANOMALY_RULE_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_SCOPED_ANOMALY_RULE_SUCCESS:
      return {
        ...state,
        deleteSuccess: true,
        error: "",
      };
    case DELETE_SCOPED_ANOMALY_RULE_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_SCOPED_ANOMALY_RULE_SUCCESS:
      return {
        ...state,
        error: "",
        updatedScopedAnomalySuccess: true,
      };
    case UPDATE_SCOPED_ANOMALY_RULE_FAILURE:
      return {
        ...state,
        error: action.payload,
        updatedScopedAnomalyFailure: true,
      };
    case CLEAR_SCOPED_ANOMALY_STATE:
      return {
        ...state,
        error: "",
        createError: "",
        deleteSuccess: false,
      };
      case HMI_REQUEST: {
        return {
          ...state,
          hmi: '',
          hmiLoading:true
        };
      }
      case FETCH_ANOMALY_HMI_SUCCESS: {
        return {
          ...state,
          hmi: action.payload,
          hmiLoading:false
        };
      }
      case FETCH_ANOMALY_HMI_FAILURE: {
        return {
          ...state,
          hmi:'',
          error: action.payload,
        };
      }
      case NODE_REQUEST: {
        return {
          ...state,
          node: '',
          nodeLoading:true
        };
      }
      case FETCH_ANOMALY_NODE_SUCCESS: {
        return {
          ...state,
          node: [...action.payload,{name:"",number:""}],
          nodeLoading:false
        };
      }
      case FETCH_ANOMALY_NODE_FAILURE: {
        return {
          ...state,
          node:'',
          nodeLoading:false,
          error: action.payload,
        };
      }
      case FUNCTION_REQUEST: {
        return {
          ...state,
          function: '',
          functionLoading:true
        };
      }
      case FETCH_ANOMALY_FUNCTION_SUCCESS: {
        return {
          ...state,
          function: [...action.payload,{name:"",number:""}],
          functionLoading:false
        };
      }
      case FETCH_ANOMALY_FUNCTION_FAILURE: {
        return {
          ...state,
          function:'',
          error: action.payload,
        };
      }
      case CLEAR_TYPE_HMI: {
        return {
          ...state,
          hmi: "",
        };
      }
      case CLEAR_TYPE_NODE: {
        return {
          ...state,
          node: "",
        };
      }
      case CLEAR_TYPE_FUNCTION: {
        return {
          ...state,
          function: "",
        };
      }
    default:
      return state;
  }
};
